import UserImage from '@components/UserImage';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@tsClient';
import * as ApiModels from '@typings/api-models';
import ProgressIndicator from '@components/ProgressIndicator';
import s from '../UserWorkflowDetail.module.scss';
import PermissionCheckBox from './PermissionCheckBox';

type Props = {
  userWorkflow: { id: string };
  collaborator: Pick<ApiModels.UserWorkflowCollaborator,
    | 'id'
    | 'color'
    | 'email'
    | 'name'
    | 'logo'
    | 'canAssign'
    | 'canHavePermissionsChanged'
    | 'canInviteCollaborators'
    | 'canReceiveCustomerNotifications'
    | 'source'
  >;
  onChange: (newCollaborator: Awaited<ReturnType<typeof tsClient.workflows.updateUserWorkflowCollaborator>>) => Promise<void> | void;
  isAllowedToChange: boolean;
};

const Collaborator: React.FC<Props> =({ isAllowedToChange, collaborator, onChange, userWorkflow }) => {
  const {
    fetchingState,
    getData: updateUserWorkflowCollaborator,
  } = useNoodleApi(tsClient.workflows.updateUserWorkflowCollaborator);

  const handleChange = async (key: string): Promise<void> => {
    if (key === 'canAssign' || key === 'canInviteCollaborators' || key === 'canReceiveCustomerNotifications') {
      const response = await updateUserWorkflowCollaborator({
        collaboratorId: collaborator.id,
        [key]: !collaborator[key],
        userWorkflowId: userWorkflow.id,
      });
      if (response.data) {
        onChange(response.data);
      }
    }
  };

  return (
    <div className={s.collaborator}>
      <div className={s['collaborator-who']}>
        <UserImage
          color={collaborator.color}
          url={collaborator.logo}
          size={24}
          key={collaborator.id}
          name={collaborator.name || ''}
        />
        <div className={s['collaborator-text']}>
          <strong>{collaborator.name}</strong>
          {collaborator.email && <small>{collaborator.email}</small>}
        </div>
      </div>
      <div className={s['permissions-area']}>
        <PermissionCheckBox
          propName='canAssign'
          collaborator={collaborator}
          onChange={handleChange}
          label="Can assign tasks"
          isAllowedToChange={isAllowedToChange}
        />
        <PermissionCheckBox
          propName='canInviteCollaborators'
          collaborator={collaborator}
          onChange={handleChange}
          label="Can invite collaborators"
          isAllowedToChange={isAllowedToChange}
        />
        <PermissionCheckBox
          propName='canReceiveCustomerNotifications'
          collaborator={collaborator}
          onChange={handleChange}
          label="Will receive customer notifications"
          isAllowedToChange={isAllowedToChange}
        />
      </div>
      {fetchingState.isFetching && (
        <div className={s['disable-collaborator']}>
          <ProgressIndicator />
        </div>
      )}
    </div>

  );
};

export default Collaborator;
